import React from "react";
import "../styles/aboutMe.css";

const aboutMe = () => {
    return (
        <div id="aboutMe">
            <h1>JIN LEE</h1>
            <div id="aboutMe_lines">
                <span id="aboutMe_lines_thick"></span>
                <span id="aboutMe_lines_thin"></span>
            </div>
            <h2>Full Stack Developer</h2>
        </div>
    );
};

export default aboutMe;